import React, {useEffect, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import IntegrationsSection from 'components/IntegrationsSection'
import { useForm } from "react-hook-form"
import Spinner from 'react-bootstrap/Spinner'
import * as Yup from 'yup'
import { DevTool } from "react-hook-form-devtools";
import FormColor from 'components/Form/FormColor'
import { updateAccountInfo } from 'store/actions/userActions'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import PricingSection from 'components/PricingSection';
import Section from 'components/Section'
import {useLocation, useHistory} from 'util/router'
import PartnerInformationPage from 'pages/partnerInformation'
import {Helmet} from 'react-helmet'
import SharePage from 'pages/share'
import FormsPage from './customForms'

function BusinessInformationForm({user, handleFormSubmission, isSaving}) {

    const { register, control, handleSubmit, setValue, getValues, formState, errors } = useForm({
        mode: 'onBlur',
        validationSchema: Yup.object({
            // partnerLogo: Yup.object(),
            primaryColor: Yup.string(),
            backgroundColor: Yup.string(),
            textColor: Yup.string()
        }),
        defaultValues: {
            primaryColor: user.instructorProfile?.primaryColor ?? "#4289FF",
            backgroundColor: user.instructorProfile?.backgroundColor ?? "#ffffff",
            textColor: user.instructorProfile?.textColor ?? "#343a40"
        }
    });

    const { dirty } = formState;

    

    const onSubmit = (data) => {

        

        console.log("Data to submit: ", data)
        // return

        if (handleFormSubmission) {
            var dataUpdate = {}
            dataUpdate.instructorProfile = {
                ...user.instructorProfile,
                primaryColor: data.primaryColor,
                backgroundColor: data.backgroundColor,
                textColor: data.textColor
            }

            console.log(dataUpdate)
            // return

            handleFormSubmission(dataUpdate)
        }
    }

    useEffect(() => {
        register({ name: 'primaryColor'})
        register({ name: 'backgroundColor'})
        register({ name: 'textColor'})
    }, [register])

    return (<>
        <form className="partnerInformationForm" onSubmit={handleSubmit(onSubmit)}>

            <section>

                <FormColor
                fullSize
                name="primaryColor"
                color={user.instructorProfile?.primaryColor ?? "#4289FF"}
                error={""}
                label="Button Color"
                sublabel="Pick a color that fits your brand!"
                onChange={(color) => setValue('primaryColor', color)}
                />

                <FormColor
                fullSize
                name="backgroundColor"
                color={user.instructorProfile?.backgroundColor ?? "#ffffff"}
                error={""}
                label="Background Color"
                sublabel="The background color of your scheduling page"
                onChange={(color) => setValue('backgroundColor', color)}
                />

                <FormColor
                fullSize
                name="textColor"
                color={user.instructorProfile?.textColor ?? "#343a40"}
                error={""}
                label="Text Color"
                sublabel="The color of the text on your scheduling page"
                onChange={(color) => setValue('textColor', color)}
                />

                <button disabled={!dirty} type="submit" className="btn btn-primary">
                        
                        <span>{"Save changes"}</span>

                        {isSaving && (
                            <Spinner
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden={true}
                            className="ml-2"
                            >
                            <span className="sr-only">Saving...</span>
                            </Spinner>
                        )}
                    </button>

            </section>
            

        </form>
        <DevTool control={control} />
    </>)
}

const titleFromKey = (key) => {
    const keys = {
        "general": "General",
        // "business-settings": "Business Settings",
        "forms": "Forms",
        "integrations": "Integrations",
        "public-page": "Public Page",
        "my-plan": "My Plan"
    }
    return keys[key] ?? "Settings"
}


function BusinessSettingsPage(props) {

    const location = useLocation();
    const history = useHistory()
    const [key, setKey] = useState(location.hash ? location.hash.replace("#", "") : "general");

    const dispatch = useDispatch()

    const user = useSelector(state => state.user.userData)
    const isLoading = useSelector(state => state.user.loading)
    const isSaving = useSelector(state => state.user.saving)
    const error = useSelector(state => state.user.error)
    const success = useSelector(state => state.user.success)

    const handleFormSubmission = (data) => {
        dispatch(updateAccountInfo(data))
    }

    return (
        <div className="container">
            <Helmet>
                <title>{titleFromKey(key)}</title>
            </Helmet>
            <Tabs
            id="controlled-tab-example"
            activeKey={key}
            onSelect={(k) => {
                history.push(location.pathname + `#${k}`)
                setKey(k)
            }}
            >
                <Tab eventKey="general" title="General">
                    <Section>
                        <PartnerInformationPage {...props}/>
                    </Section>
                    
                </Tab>

                <Tab eventKey="public-page" title="Public Page">
                    <Section>
                        <SharePage {...props}>
                            {!isLoading && user.platformID ? (
                                <div>
                                    {success && (
                                        <div className="alert alert-success" role="alert">
                                            {success}
                                        </div>
                                    )}
                                    {error && (
                                        <div className="alert alert-danger" role="alert">
                                            {error}
                                        </div>
                                    )}
                                    <BusinessInformationForm
                                    user={user}
                                    handleFormSubmission={handleFormSubmission}
                                    isSaving={isSaving}
                                    />
                                </div>
                            ) : (
                                <div>loading</div>
                            )}
                        </SharePage>
                    </Section>
                </Tab>

                {user && user.platformID && ['5x0TQEZh7Hdk7lgcgYrzhU52zI93', 'l2hWkuaSo4csUnVffJjO', 'v18oWJId6bRZMadvSqtNjtj5Ahf1'].includes(user.platformID) && (
                    <Tab eventKey="forms" title="Forms">
                        <Section>
                            <FormsPage {...props}/>
                        </Section>
                    </Tab>
                )}

                <Tab eventKey="integrations" title="Integrations">
                    <Section>
                        <div className="d-flex flex-column col-md-9 col-xl-6">
                            <IntegrationsSection {...props}/>
                        </div>
                    </Section>
                </Tab>
                <Tab eventKey="my-plan" title="My Plan">
                    {user.platformID ? (
                        <PricingSection studioMode={user.studioMode === true}></PricingSection>
                    ) : (
                        <>Loading</>
                    )}
                    
                </Tab>
            </Tabs>
        </div>
    )
    
}

export default BusinessSettingsPage;